import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { EmailValidator, NoWhitespaceValidator, ToastService } from '@wephone-utils';
import { StorageService } from '@wephone-core/service/storage.service';
import { FlexBaseComponent } from '@wephone-core-ui';
import { _tk, _ti } from '@wephone-translation';
import { NoHtmlAndCurlyBracesValidator } from '@wephone-utils/validator/no-html-and-curly-braces-validator';
import { XSSValidator } from '@wephone-utils/validator/xss-validator';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent extends FlexBaseComponent implements OnInit {
  registerForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public authService: AuthenticationService,
    public toast: ToastService,
    public storage: StorageService
  ) {
    super();
  }

  ngOnInit(): void {
    this.registerForm = this.fb.group({
      lastName: [
        undefined,
        [Validators.compose([Validators.required, Validators.maxLength(50)]), NoWhitespaceValidator, NoHtmlAndCurlyBracesValidator(), XSSValidator.sanitize]
      ],
      firstName: [
        undefined,
        [Validators.compose([Validators.required, Validators.maxLength(50)]), NoWhitespaceValidator, NoHtmlAndCurlyBracesValidator(), XSSValidator.sanitize]
      ],
      company: [undefined, [Validators.compose([Validators.required]), NoWhitespaceValidator, NoHtmlAndCurlyBracesValidator(), XSSValidator.sanitize]],
      domain: [undefined, [Validators.compose([Validators.required]), NoWhitespaceValidator, NoHtmlAndCurlyBracesValidator(), XSSValidator.sanitize]],
      country: [undefined, [Validators.compose([Validators.required])]],
      email: [undefined, [Validators.compose([Validators.required]), EmailValidator]],
      password: [undefined, [Validators.compose([Validators.required])]]
    });
  }

  async register(): Promise<void> {
    const registerCredentials = {
      last_name: this.registerForm.get('lastName').value,
      first_name: this.registerForm.get('firstName').value,
      company: this.registerForm.get('company').value,
      domain: this.registerForm.get('domain').value,
      country: this.registerForm.get('country').value,
      email: this.registerForm.get('email').value,
      password: this.registerForm.get('password').value
    };

    try {
      const res = await this.authService.register(registerCredentials);

      if (res.user) {
        this.toast.show(_ti('register.message.register_success'));
        await this.authService.setLastDomain(registerCredentials.domain);
        await this.storage.setDomainTempData('user_name', res.user.email);
        this.router.navigate(['/s/signin']);
      } else {
        this.toast.showError(_ti('register.message.register_error'));
      }
    } catch (e) {
      // console.error('Signup failed: ', e);
      this.toast.showErrorMessage(e, _ti('register.message.register_error'));
    }
  }
}
